import React, { FC } from 'react';

import { IContract } from 'types';
import { ORGANIZATION_TYPE_LABELS, USER_TYPE_LABELS } from 'constants/enums';
import { formatDate, formatSum } from 'utils/format';
import { DetailsRow } from 'components/ProfileDetailsRow/DetailsRow';
import styles from './ContractDetails.module.scss';

export const ContractDetails: FC<IContract> = ({
  dateStart,
  dateClose,
  dateEnd,
  organization,
  summa,
  typeContract
}) => {
  return (
    <div className={styles.scrollwrapper}>
     <div className={styles.scroll}> 
       <div className={styles.wrapper}>
        <div className={styles.toprow}>
         <DetailsRow className={styles.item} title="Дата открытия" value={formatDate(dateStart)} />
         <DetailsRow className={styles.item} title="Дата закрытия" value={formatDate(dateClose)} />
         <DetailsRow className={styles.item} title="Дата окончания" value={formatDate(dateEnd)} />
         </div>
         <div className={styles.toprow}>
         <DetailsRow className={styles.item} title="Организация" value={ORGANIZATION_TYPE_LABELS[organization]} />
         <DetailsRow className={styles.item} title="Сумма инвестирования" value={formatSum(summa) + ' ₽'} />
         <DetailsRow className={styles.item} title="Тип лица" value={USER_TYPE_LABELS[typeContract]} />
         </div>
       </div>
     </div>
    </div>
  );
};